// IDs alineados con tbl_vtf_estadoreserva
export const STATUS = {
  CANCELLED_LEGACY: 0, // Cancelada (registros legacy)
  PENDING: 1,          // Creada/Pendiente
  CONFIRMED: 2,        // Confirmada
  RESCHEDULED: 3,      // Reprogramada
  CANCELLED: 4,        // Cancelada
  EXECUTED: 5,         // Ejecutada
  PARTIAL: 6,          // Ejecutada Parcial
  EN_COMANDA: 7,       // Pagando / En comanda
  ATTENDED: 8,         // Atendida / Cobrada
  NO_SHOW: 9,          // Retrasada / No se presentó
} as const;

export const STATUS_OPTIONS = [
  {
    id: STATUS.PENDING,
    name: "Pendiente",
    color: "#2196F3",
  },
  {
    id: STATUS.CONFIRMED,
    name: "Confirmada",
    color: "#7886CB",
  },
  {
    id: STATUS.RESCHEDULED,
    name: "Reprogramada",
    color: "#4090B5",
  },
  {
    id: STATUS.CANCELLED,
    name: "Cancelada",
    color: "#616161",
  },
  {
    id: STATUS.EXECUTED,
    name: "Ejecutada",
    color: "#33B679",
  },
  {
    id: STATUS.EN_COMANDA,
    name: "En comanda",
    color: "#F2811D",
  },
  {
    id: STATUS.ATTENDED,
    name: "Atendida",
    color: "#2E7D32",
  },
  {
    id: STATUS.NO_SHOW,
    name: "No se presentó",
    color: "#E67C73",
  },
];
